var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('doctor-table',{attrs:{"canDelete":true,"viewRoute":"FranchiseDoctorEdit","canCreate":true,"createRoute":"FranchiseDoctorCreate","viewDetailRoute":"FranchiseDoctorDetailView","canRequestAssociation":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }